<template>
  <section class="q-pa-sm" aria-label="Warehouse location mapping">
    <p>{{ $t('Select a location, scan its existing label, then confirm the pair.') }}</p>
    <q-form v-if="!place" @submit="selectLocation">
      <h6 class="q-my-sm">{{ $t('1. Select location') }}</h6>
      <q-input v-model="target" :label="$t('Canonical location code or linked label')" :disable="busy" />
      <q-btn type="submit" :label="$t('Select location')" :disable="busy || !target" />
    </q-form>
    <template v-else>
      <p data-testid="mapping-location"><strong>{{ place.internalCode }}</strong>
        {{ (place.path || []).join(' / ') }} {{ place.placeAlias }}</p>
      <q-form v-if="!linked" @submit="reviewMapping">
        <h6 class="q-my-sm">{{ $t('2. Scan existing label') }}</h6>
        <q-input v-model="label" :label="$t('Existing warehouse label')" :disable="busy || review" />
        <q-btn v-if="!review" type="submit" :label="$t('Review mapping')" :disable="busy || !label" />
      </q-form>
      <div v-if="review" class="q-pa-md bg-grey-2 text-dark" data-testid="mapping-review">
        <h6 class="q-my-sm">{{ $t('3. Confirm mapping') }}</h6>
        <p><code style="white-space: pre-wrap; overflow-wrap: anywhere">{{ label }}</code> → <strong>{{ place.internalCode }}</strong></p>
        <p>{{ $t('This adds a label to the location. Its code and stock stay unchanged.') }}</p>
        <q-btn color="primary" :label="$t('Confirm mapping')" :loading="busy" :disable="busy" @click="confirmMapping" />
        <q-btn flat :label="$t('Edit label')" :disable="busy" @click="review = false" />
      </div>
      <div v-if="linked" role="status" class="q-pa-md">
        <p>{{ $t('Label mapped successfully') }}</p>
        <q-btn color="primary" :label="$t('Map next location')" :disable="busy" @click="reset" />
        <q-btn flat :label="$t('Add another label here')" :disable="busy" @click="anotherLabel" />
      </div>
      <q-btn v-else flat :label="$t('Select another location')" :disable="busy" @click="reset" />
    </template>
    <div v-if="error" role="alert" class="text-negative">{{ error }}</div>
    <q-expansion-item :label="$t('Search and bulk mapping')">
      <location-alias-tools :warehouse-id="warehouseId" @select="selectSearchResult" />
    </q-expansion-item>
    <q-expansion-item v-if="recent.length" :label="$t('Mapped this session')">
      <ul><li v-for="(item, index) in recent" :key="index"><code>{{ item.raw }}</code> → {{ item.internalCode }}</li></ul>
    </q-expansion-item>
  </section>
</template>
<script>
import mapping from './location-mapping.mjs';
import LocationAliasTools from './LocationAliasTools.vue';
export default { mixins: [mapping], components: { LocationAliasTools }, emits: ['linked'] };
</script>
